export default "__VITE_ASSET__da4a458c__"